import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import getFormattedTime from '@utils/date/getFormattedTime';
import messages from './messages';

function ScheduleShifts({ shifts, timeFormat }) {
  return shifts.map((shift, index) => (
    <span
      key={shift.id}
      className={classnames('shift', { first: index === 0 })}
    >
      <FormattedMessage
        {...messages.scheduleText}
        values={{
          from: getFormattedTime(timeFormat, shift.from),
          to: getFormattedTime(timeFormat, shift.to),
        }}
      ></FormattedMessage>
    </span>
  ));
}

ScheduleShifts.propTypes = {
  shifts: PropTypes.arrayOf(
    PropTypes.shape({ to: PropTypes.string, from: PropTypes.string }),
  ),
  timeFormat: PropTypes.string.isRequired,
};

export default React.memo(ScheduleShifts);
